<template>
    <div class="signInForm">
        <div class="mx-3 pt-4 pb-1">
            <div class="d-flex justify-content-center align-items-center">
                <img border="0" :src="imgPath" width="120" height="120" alt="">
            </div>
            <h2 class="text-center py-3 bg-single comment-color">パスワード再設定</h2>
            <p class="text-center mb-4 bg-single comment-color">パスワードの再設定が完了しました。<br></p>
            <p class="text-center mb-4 bg-single comment-color" v-if="info_flag">アプリにてログアウト後、新しいパスワードで再度ログインしてください。<br></p>
            <p class="text-center mb-4 bg-single comment-color" v-else>メールが届かない場合は下記までお問合せください。<br>{{ info_mail }}</p>
            <div class="text-center mb-4" v-if="btnUse">
                <button
                    type="button"
                    class="confirmbutton col-sm-4"
                    @click="toLoginPage()"
                >
                    {{ btnName }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            btnName: '',
            btnUse: false,
            info_flag: process.env.MIX_STYLE_NAME == 'hcgc' ? true: false,
            info_mail: process.env.MIX_SUPPORT_MAILADDRESS,
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png"
        };
    },
    created () {
        this.initialize();
    },
    beforeRouteLeave (to, from, next) {
        if (to.path === '/passreset-setting') {
            next(false);
        } else {
            next();
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function() {
            if (process.env.MIX_APP_URL) {
                this.btnUse = true;
                this.btnName = 'アプリを起動';
            } else {
                this.btnUse = true;
                this.btnName = 'ログインページに戻る';
            }
        },
        toLoginPage: function () {
            if (process.env.MIX_APP_URL) {
                window.location.href = process.env.MIX_APP_URL;
            } else {
                this.$router.push({ path: '/' });
            }
        }
    }
}
</script>

<style scoped>
    .signInForm {
        height: 100vh;
    }
</style>
